import { ApiCaller } from '../../utils/api'
import { URLS } from '../../utils/url'
const state = {
  currentClinics: [],
  membershipChargeClinic: [],
  membershipSubscriptClinic: [],
  currentClinicCustomerNotes: [],
  currentClinic: {},
}

const mutations = {
  SET_CURRENT_CLINICS(state, payload) {
    state.currentClinics = [].concat(payload)
  },
  SET_MEMBERSHIP_CHARGE_CLINICS(state, payload) {
    state.membershipChargeClinic = [].concat(payload)
  },
  SET_MEMBERSHIP_SUBSCRIPT_CLINICS(state, payload) {
    state.membershipSubscriptClinic = [].concat(payload)
  },
  SET_CLINIC_CUSTOMER_NOTE(state, payload) {
    state.currentClinicCustomerNotes = [].concat(payload)
  },
  SET_CURRENT_CLINIC(state, payload) {
    state.currentClinic = payload
  }
}
const actions = {
  async fetchCurrentClinics({ state, commit }, query) {
    const response = await ApiCaller().get(URLS.COUPON_CLINICS(), {params: {query: query}})
    if (response) {
      commit('SET_CURRENT_CLINICS', response.data.data)
    }
  },
  async fetchMembershipChargeClinics({ state, commit }, query) {
    const response = await ApiCaller().get(URLS.POINT_CLINICS(), {params: {query: query}})
    if (response) {
      commit('SET_MEMBERSHIP_CHARGE_CLINICS', response.data.data)
    }
  },
  async fetchPointClinics({ state, commit }, type) {
    const response = await ApiCaller().get(URLS.POINT_CLINICS(), { params: {type: type}})
    if (response) {
      commit('SET_CURRENT_CLINICS', response.data.data)
    }
  },
  async fetchCurrentClinicCustomerNotes({ state, commit }, object) {
    const response = await ApiCaller().get(URLS.CURRENT_CLINIC_CUSTOMER_NOTES(), {
      params: Object.assign({}, {
        clinic_id: object.clinic_id,
        query: object.query
      })
    })
    if (response) {
      commit('SET_CLINIC_CUSTOMER_NOTE', response.data.data)
    }
  },
  async fetchCurrentClinic({ state, commit }) {
    const response = await ApiCaller().get(URLS.CURRENT_CLINIC())
    if (response) {
      commit('SET_CURRENT_CLINIC', response.data.data)
    }
  },
}

export default {
  namespaced: true,
  state, mutations, actions
}
